<template>
    <Projects :allow-all="allowAll" />
</template>

<script>
    import Projects from './Projects'

    export default {
        name: 'ProjectSelector',
        components: { Projects },
        props: {
            allowAll: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
